import type {ReactNode} from 'react';
import React, {useEffect, useMemo, useState} from 'react';
import ReactDOM from 'react-dom';
import {Utility} from '@/components/GridWidget';
import {Enum} from '@/enums/system';
import FormBudgetProjectApprovalApp from '@/pages/project/GeneralProjectApproval/components/approval';
import FormBudgetProjectApplyApp from '@/pages/project/GeneralProjectApply/components/apply';
import type {WdiModalAppResult} from '../WdiControls';
import GeneralSettleApplyApp from '@/pages/sales/ss/GeneralSettleApply/components/apply';
import FreeGoodsApplyApp from '@/pages/sales/sa/FreeGoodsApply/components/apply';
import BudgetProjectDisplayApp from '@/pages/project/BudgetProject/components/BudgetProjectDisplay';
import GeneralActivityApplyApp from '@/pages/sales/sa/GeneralActivityApply/components/Apply';
import GeneralActivityApprovalApp from '@/pages/sales/sa/GeneralActivityApproval/components/approval';
import GeneralSettleApprovalApp from '@/pages/sales/ss/GeneralSettleApproval/components/approval';
import FGActivityApprovalApp from '@/pages/sales/sa/FreeGoodsApproval/components/approval';
import {GlobalPromptInstance} from '../WdiControls/WdiPromptContext';
import SalesContractApproval from '@/pages/contract/SalesContractApproval/components/approval';
import SalesContractApply from '@/pages/contract/SalesContractApply/components/apply';
import {WdiDrawer} from '../WdiControls/WdiDrawer';
import {ConfigProvider, message, Space, Spin} from 'antd';
import {ApprovalButton, MoreWapper, WdiButtonContainer} from './Buttons';
import PriceDiscountApplyApp from '@/pages/sales/sa/PriceDiscountApply/components/Apply';
import {FormApi} from '@/services/sales';
import {ResponseStatus} from '@/utils/request';
import PriceDiscountApprovalApp from '@/pages/sales/sa/PriceDiscountApproval/components/approval';
import zhCN from 'antd/lib/locale/zh_CN';
import {ResponseCode} from '@/utils/response';
import MktApplyApp from '@/pages/mkt/sa/MktApply/components/Apply';
import MktApprovalApp from '@/pages/mkt/sa/MktApproval/components/approval';
import ProductPolicyApplyApp from '@/pages/policy/ProductPolicyApply/components/apply';
import PaymentMktApplyApp from '@/pages/mkt/sp/GeneralPaymentApply/components/apply';
import {RebatePaymentArApplyApp} from '@/pages/contract/RebatePaymentApply/components/RebatePaymentArApply';
import {RebatePaymentTpApplyApp} from '@/pages/contract/RebatePaymentApply/components/RebatePaymentTpApply';
import {RebatePaymentBdApplyApp} from '@/pages/contract/RebatePaymentApply/components/RebatePaymentBdApply';
import {RebatePaymentFgApplyApp} from '@/pages/contract/RebatePaymentApply/components/RebatePaymentFgApply';
import ProductPolicyApprovalApp from '@/pages/policy/ProductPolicyApproval/components/approval';
import PaymentMktApprovalApp from '@/pages/mkt/sp/GeneralPaymentApproval/components/approval';
import FreeGoodsPaymentApplyApp from '@/pages/sales/sp/FreeGoodsPaymentApply/components/apply';
import AccountReducePaymentApplyApp from '@/pages/sales/sp/AccountReducePaymentApply/components/apply';
import BillDeductPaymentApplyApp from '@/pages/sales/sp/BillDeductPaymentApply/components/apply';
import ThirdPartPaymentApplyApp from '@/pages/sales/sp/ThirdPartPaymentApply/components/apply';
import FreeGoodsPaymentApprovalApp from '@/pages/sales/sp/FreeGoodsPaymentApproval/approval';
import PrePaymentApplyApp from '@/pages/sales/sp/PrePaymentApply/components/apply';
import PrePaymentApprovalApp from '@/pages/sales/sp/PrePaymentApproval/components/approval';
import {RebatePaymentApprovalApp} from '@/pages/contract/RebatePaymentApproval/components/RebatePaymenApproval';
import GeneralPaymentApprovalApp from '@/pages/sales/sp/GeneralPaymentApproval/components/Approval';
import BatchPaymentApplyApp from "@/pages/sales/sp/BatchPaymentApply/components/Apply";

export enum PageMode {
  Apply = 1,
  Approval = 2,
  Modify = 3,
};

export enum ModuleType {
  Form = 1,
  Project = 2,
  Contract = 3,
  Policy = 4,
  PoolPrepayReverse = 5,
};

export enum OpenMode {
  Page = 1,
  Drawer = 2
}

export type ParamsProps = {
  formId?: number;
  relatedFormId?: number;
  relatedType?: number;
  pageTypeId?: number;
  pageGroupId?: number;
  soldToMasterCode?: string;
  year?: number;
  prepayType?: number;
  bohqId?: number;
  formTypeId?: number;
  supplierId?: number;
  soldToCode?: string;
  [key: string]: any;
};

export type FormPageProps = {
  id?: number | string;
  pageTypeId?: number;
  formTypeId?: number;
  bohqId?: number;
  data?: ParamsProps;
  mode?: PageMode;
  openMode?: OpenMode;
  moduleType?: ModuleType;
  key?: string;
  children?: React.ReactNode;
  callback?: (result?: WdiModalAppResult) => void;
  setPageTitle?: (title?: ReactNode) => void;
  onClose?: (result?: WdiModalAppResult) => void;
  setLoading?: (loading: boolean) => void;
  /**关闭确认函数，用来代替默认的 window.confirm */
  onCloseConfirm?: () => boolean;
  /**关闭确认信息 */
  closeConfirmMessage?: () => string;
  /**禁用关闭确认,这个是优先级最高的判断 */
  disableCloseConfirm?: boolean;
}

export interface PageControl {
  show: (props: FormPageProps) => void;
  apply: (props: FormPageProps) => void;
  approval: (props: FormPageProps) => void;
}

const WdiPageDrawer: React.FC<FormPageProps> = (props: FormPageProps) => {
  const [visible, setVisible] = useState<boolean>(true);
  const [title, setTitle] = useState<ReactNode>();
  const [loading, setLoading] = useState(false);
  const {onCloseConfirm, disableCloseConfirm, closeConfirmMessage, ...newProps} = props;

  const promptMessage = () => closeConfirmMessage?.() || '系统不会保存您所做的更改，确定要关闭此界面吗？';
  const hasConfirm = disableCloseConfirm
    ? false
    : (null != onCloseConfirm || props.mode === PageMode.Apply || props.mode === PageMode.Modify);
  useEffect(
    () => {
      if (visible) {
        GlobalPromptInstance.addPageChangeListener(closeDrawer);
        if (hasConfirm) {
          GlobalPromptInstance.setEnable(true);
          GlobalPromptInstance.setPromptMessage(promptMessage);
        }
      }
    },
    []
  );
  const closeDrawer = () => {
    setVisible(false);
    GlobalPromptInstance.popPageChangeListener();
    if (hasConfirm) {
      GlobalPromptInstance.setEnable(false);
      GlobalPromptInstance.popPromptMessage();
    }
  }

  const onClose = (result?: WdiModalAppResult) => {
    if (disableCloseConfirm
      || onCloseConfirm?.()
      || (props.mode !== PageMode.Apply && props.mode !== PageMode.Modify)
      || result?.code == ResponseCode.SUCCESS
      || window.confirm(promptMessage())
    ) {
      closeDrawer();
    }
  }
  const setPageTitle = useMemo(() => {
    return (newTitle?: ReactNode) => {
      setTitle(newTitle)
    };
  }, []);
  const onLoading = (loading: boolean) => {
    setLoading(loading);
  }

  newProps.setLoading = onLoading;
  newProps.setPageTitle = setPageTitle;
  newProps.onClose = onClose;
  const Component = getComp(Number(props.pageTypeId), Number(props.formTypeId), Number(props.data?.policyType), props.mode, props.moduleType);
  return (
    <WdiDrawer
      headerStyle={{padding: '16px 24px'}}
      bodyStyle={{padding: '0 32px', paddingBottom: 20, minWidth: 800}}
      onClose={() => {
        onClose()
      }}
      title={title}
      visible={visible}
    >
      {/* 本项目没有中英文，默认写死中文，若配置国际化，需要使用getLocale()获取当前语言判断使用哪个 */}
      <ConfigProvider locale={zhCN}>
        <Spin spinning={loading && (props.mode == PageMode.Apply || props.mode == PageMode.Modify)}
              size='large'>
          <Component {...newProps} />
        </Spin>
      </ConfigProvider>
    </WdiDrawer>
  );
}

const Empty: React.FC<FormPageProps> = (props: FormPageProps) => {
  useEffect(() => {
    if (props.setPageTitle) {
      props.setPageTitle('无效的单据');
    }
  }, [props.setPageTitle]);
  return (
    <></>
  )
}
export const getFormUrlMapping = (pageTypeId: number, formTypeId: number) => {
  if (formTypeId === Enum.FormType.PROJECT_APPLICATION) {
    if (pageTypeId === Enum.PageType.PROJECT_GENERAL || pageTypeId === Enum.PageType.PROJECT_GENERAL_PLANNING) {
      return '/project/GeneralProjectApproval/';
    }
  } else if (formTypeId === Enum.FormType.ACTIVITY_APPLICATION) {
    if (pageTypeId === Enum.PageType.ACTIVITY_APPLICATION) {
      return '/sales/sa/GeneralActivityApproval/';
    } else if (pageTypeId === Enum.PageType.PRICE_DISCOUNT_APPLICATION) {
      return '/sales/sa/PriceDiscountApproval/';
    } else if (pageTypeId === Enum.PageType.FREE_GOODS_APPLICATION) {
      return '/sales/sa/FreeGoodsApproval/';
    } else if (pageTypeId === Enum.PageType.APP_FREE_GOODS_APPLICATION) {
      return '/sales/sa/FreeGoodsApproval';
    }
  } else if (formTypeId === Enum.FormType.ACTIVITY_SETTLEMENT) {
    if (pageTypeId === Enum.PageType.ACTIVITY_SETTLEMENT) {
      return '/sales/ss/GeneralSettleApproval/';
    }
  } else if (formTypeId === Enum.FormType.ACTIVITY_PAYMENT) {
    return '/sales/sp/generalpaymentapproval';
  } else if (formTypeId === Enum.FormType.CONTRACT_REBATE_PAYMENT) {
    return '/contract/rebatepaymentapproval';
  } else if (formTypeId === Enum.FormType.REBATE_INFO) {
    if (pageTypeId === Enum.PageType.CONTRACT_REBATE || pageTypeId === Enum.PageType.CONTRACT_REBATE_LEVEL_2) {
      return '/contract/SalesContractApproval';
    }
  } else if (formTypeId === Enum.FormType.PRE_ACTIVITY) {
    if (pageTypeId === Enum.PageType.PRE_ACTIVITY) {
      return '/sales/presa/preactivityapproval';
    }
  } else if (formTypeId === Enum.FormType.ACTIVITY_MKT_APPLICATION) {
    if (pageTypeId === Enum.PageType.MKT_APPLICATION) {
      return '/mkt/sa/mktapproval/';
    }
  } else if (formTypeId === Enum.FormType.ACTIVITY_MKT_PAYMENT) {
    if (pageTypeId === Enum.PageType.PAYMENT_MKT) {
      return '/mkt/sp/paymentmktapprovalapp/';
    }
  } else if (formTypeId === Enum.FormType.PRE_PAYMENT) {
    if (pageTypeId === Enum.PageType.PRE_PAYMENT_THIRD_PART) {
      return '/sales/sp/prepaymentapproval';
    }
  }
  return '';
}
const getComp = (pageTypeId: number, formTypeId: number, policyTypeId: number, mode?: PageMode, moduleType?: ModuleType) => {
  if (ModuleType.Project === moduleType) {
    return BudgetProjectDisplayApp;
  } else if (ModuleType.Contract === moduleType) {
    if (mode === PageMode.Apply) {
      return SalesContractApply;
    } else if (mode === PageMode.Approval) {
      return SalesContractApproval;
    }
  } else if (ModuleType.Form === moduleType) {
    if (mode === PageMode.Approval) {
      if (formTypeId === Enum.FormType.PROJECT_APPLICATION) {
        if (pageTypeId === Enum.PageType.PROJECT_GENERAL || pageTypeId === Enum.PageType.PROJECT_GENERAL_PLANNING) {
          return FormBudgetProjectApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_APPLICATION) {
        if (pageTypeId === Enum.PageType.FREE_GOODS_APPLICATION) {
          return FGActivityApprovalApp;
        } else if (pageTypeId === Enum.PageType.ACTIVITY_APPLICATION) {
          return GeneralActivityApprovalApp;
        } else if (pageTypeId === Enum.PageType.PRICE_DISCOUNT_APPLICATION) {
          return PriceDiscountApprovalApp;
        } else if (pageTypeId === Enum.PageType.APP_FREE_GOODS_APPLICATION) {
          return FGActivityApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_SETTLEMENT) {
        if (pageTypeId === Enum.PageType.ACTIVITY_SETTLEMENT) {
          return GeneralSettleApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.CONTRACT_REBATE_PAYMENT) {
        if (
          pageTypeId === Enum.PageType.PAYMENT_CONTRACT_ACCOUNT_REDUCE ||
          pageTypeId === Enum.PageType.PAYMENT_CONTRACT_THIRD_PART ||
          pageTypeId === Enum.PageType.PAYMENT_CONTRACT_BILL_DEDUCT ||
          pageTypeId === Enum.PageType.PAYMENT_CONTRACT_FREE_GOODS
        ) {
          return RebatePaymentApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_PAYMENT) {
        if (pageTypeId === Enum.PageType.PAYMENT_FREE_GOODS) {
          return FreeGoodsPaymentApprovalApp;
        } else {
          return GeneralPaymentApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_MKT_APPLICATION) {
        if (pageTypeId === Enum.PageType.MKT_APPLICATION) {
          return MktApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_MKT_PAYMENT) {
        if (pageTypeId === Enum.PageType.PAYMENT_MKT) {
          return PaymentMktApprovalApp;
        }
      } else if (formTypeId === Enum.FormType.PRE_PAYMENT) {
        if (pageTypeId === Enum.PageType.PRE_PAYMENT_THIRD_PART) {
          return PrePaymentApprovalApp;
        }
      }
    } else if (mode === PageMode.Apply) {
      if (formTypeId === Enum.FormType.PROJECT_APPLICATION) {
        if (pageTypeId === Enum.PageType.PROJECT_GENERAL || pageTypeId === Enum.PageType.PROJECT_GENERAL_PLANNING) {
          return FormBudgetProjectApplyApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_APPLICATION) {
        if (pageTypeId === Enum.PageType.FREE_GOODS_APPLICATION) {
          return FreeGoodsApplyApp;
        } else if (pageTypeId === Enum.PageType.ACTIVITY_APPLICATION) {
          return GeneralActivityApplyApp;
        } else if (pageTypeId === Enum.PageType.PRICE_DISCOUNT_APPLICATION) {
          return PriceDiscountApplyApp;
        } else if (pageTypeId === Enum.PageType.APP_FREE_GOODS_APPLICATION) {
          return FreeGoodsApplyApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_SETTLEMENT) {
        if (pageTypeId === Enum.PageType.ACTIVITY_SETTLEMENT) {
          return GeneralSettleApplyApp;
        }
      } else if (formTypeId === Enum.FormType.CONTRACT_REBATE_PAYMENT) {
        if (pageTypeId === Enum.PageType.PAYMENT_CONTRACT_ACCOUNT_REDUCE) {
          return RebatePaymentArApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_CONTRACT_THIRD_PART) {
          return RebatePaymentTpApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_CONTRACT_BILL_DEDUCT) {
          return RebatePaymentBdApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_CONTRACT_FREE_GOODS) {
          return RebatePaymentFgApplyApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_PAYMENT) {
        if (pageTypeId === Enum.PageType.PAYMENT_ACCOUNT_REDUCE) {
          return AccountReducePaymentApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_THIRD_PART) {
          return ThirdPartPaymentApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_BILL_DEDUCT) {
          return BillDeductPaymentApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_FREE_GOODS) {
          return FreeGoodsPaymentApplyApp;
        } else if (pageTypeId === Enum.PageType.PAYMENT_BATCH_ACCOUNT_REDUCE
          || pageTypeId === Enum.PageType.PAYMENT_BATCH_THIRD_PART
          || pageTypeId === Enum.PageType.PAYMENT_BATCH_BILL_DEDUCT) {
          return BatchPaymentApplyApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_MKT_APPLICATION) {
        if (pageTypeId === Enum.PageType.MKT_APPLICATION) {
          return MktApplyApp;
        }
      } else if (formTypeId === Enum.FormType.ACTIVITY_MKT_PAYMENT) {
        if (pageTypeId === Enum.PageType.PAYMENT_MKT) {
          return PaymentMktApplyApp;
        }
      } else if (formTypeId === Enum.FormType.PRE_PAYMENT) {
        if (pageTypeId === Enum.PageType.PRE_PAYMENT_THIRD_PART) {
          return PrePaymentApplyApp;
        }
      }
    }
  } else if (ModuleType.Policy === moduleType) {
    if (mode === PageMode.Apply) {
      return ProductPolicyApplyApp;
    } else if (mode === PageMode.Approval) {
      return ProductPolicyApprovalApp;
    }
  }
  return Empty;
}

const getContainer = (key?: string) => {
  const id = String(key ? key : 'form-modal');
  let container = document.getElementById(id)
  if (!container) {
    container = document.createElement('div')
    container.setAttribute('id', id)
    document.body.appendChild(container)
  }
  return container;
}

const show = (props: FormPageProps) => {
  const {...newProps} = props;
  const container = getContainer(props.key);
  ReactDOM.render(<WdiPageDrawer {...newProps} />, container);
}

const api: PageControl = {
  show: (props: FormPageProps) => {
    const newProps = {...props, openMode: OpenMode.Drawer};
    if (!newProps.key) {
      newProps.key = Utility.guid();
    }
    show(newProps)
  },
  apply: (props: FormPageProps) => {
    const newProps = {mode: PageMode.Apply, moduleType: ModuleType.Form, openMode: OpenMode.Drawer, ...props};
    if (!newProps.key) {
      newProps.key = Utility.guid();
    }
    show(newProps)
  },
  approval: (props: FormPageProps) => {
    const newProps = {mode: PageMode.Approval, moduleType: ModuleType.Form, openMode: OpenMode.Drawer, ...props};
    if (newProps.moduleType == ModuleType.Form) {
      FormApi.doesAccess(props.data?.formId).then(response => {
        if (response.code == ResponseStatus.SUCCESS && response.data) {
          if (!newProps.key) {
            newProps.key = Utility.guid();
          }
          show(newProps)
        } else {
          message.error("没有权限查看单据");
        }
      })
    } else {
      if (!newProps.key) {
        newProps.key = Utility.guid();
      }
      show(newProps)
    }
  }
}

export default api;

export const WdiFormPageTitle: React.FC<any> = (props) => {
  const {title, moreConfig, approvalConfig, ...newProps} = props
  return (
    <div>
      <span>{title}</span>
      <WdiButtonContainer>
        <Space>
          <MoreWapper
            {...newProps}
            {...moreConfig}
          />
          <ApprovalButton
            {...newProps}
            {...approvalConfig}
          />
        </Space>
      </WdiButtonContainer>
    </div>
  );
}
